// extracted by mini-css-extract-plugin
module.exports = {"container":"BrandCard_container__2CE8c","image":"BrandCard_image__SLM2Q","name":"BrandCard_name__26JUC","count":"BrandCard_count__3WWx8"};